'use client'

import BlogNewsletterSignup from '@/app/components/blog/BlogNewsletterSignup'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { FC, useState } from 'react'

interface Props {
	lang: string
}

const BlogNewsletterSignupWrapper: FC<Props> = ({ lang }) => {
	const [queryClient] = useState(() => new QueryClient())

	return (
		<QueryClientProvider client={queryClient}>
			<BlogNewsletterSignup lang={lang} />
		</QueryClientProvider>
	)
}

export default BlogNewsletterSignupWrapper
